module.exports = __webpack_public_path__ + "img/icon.5214427c.png";